<iframe [attr.data-cy]="'support-form'" #iFrame [src]="getURL() | async | safeResourceUrl"
        title="Support form"></iframe>
